( function( $ ){
  var defaults = {
  }
  var methods = {
    init: function( aOptions ){
      var settings = $.extend ( {}, defaults, aOptions )
      return $(this).each( function(){
        // console.log('mutuallyExclusive.init()');
        var $this = $( this ),
          data = $this.data('widget'),
          exclusiveInput = $this.find('input.exclusive'),
          otherInputs = $this.find('input, select, textarea').not('.exclusive');

        exclusiveInput.bind('change', function(evt){
          $this.mutuallyExclusive('clearOthers', $(this));
        });
        otherInputs.bind('change', function(evt){
          $this.mutuallyExclusive('clearExclusive');
        });

        if ( !data ) {
          $this.data('settings', settings);
          $this.data('exclusiveInput', exclusiveInput);
          $this.data('otherInputs', otherInputs);
        }
      })
    },
    clearExclusive: function(){
      // console.log('mutuallyExclusive::clearExclusive');
      var $this = $(this),
          exclusiveInput = $this.data('exclusiveInput')
          otherInputs = $this.data('otherInputs');
      otherInputs.each(function(){
        if( $(this).prop('checked') || $(this).val() ){
          exclusiveInput.prop('checked', false);
        }
      });
    },
    clearOthers: function(exclusiveChanged){
      // console.log('mutuallyExclusive::clearOthers');
      var $this = $(this) //referrs to plugin
      if( exclusiveChanged.prop('checked') ){
          $this.children().not(exclusiveChanged).each(function(){
            if( $(this).prop('tagName') == 'INPUT' && ( $(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio' ) ){
              $(this).prop('checked', false);
            }else{
              $(this).val('');
            }
         })
      }
    }
  }

  $.fn.mutuallyExclusive = function( method ) {
    if ( methods[method] ) {
        return methods[ method ].apply(this, Array.prototype.slice.call(arguments, 1));
    }else if ( typeof method === 'object' || ! method) {
        return methods.init.apply(this, arguments);
    }else{
        $.error( 'Method '+method+' does not exist on jQuery.mutuallyExclusive' );
    }
  }
} ( jQuery ) );